import { computed, ref, watch } from '@vue/composition-api';
import useTaxiTransaction from '@/modules/taxi/composables/useTaxiTransaction';
import useUtils from '@/composables/useUtils';

const useTaxiTransactionsList = () => {
  const { fetchTransactions } = useTaxiTransaction();
  const { formatDateYyyyMmDd, convertDateToUTC } = useUtils();

  const perPageOptions = [10, 25, 50, 100];
  const tableColumns = [
    { key: 'id', label: '#', sortable: true },
    { key: 'transactionStatusId', label: 'Status' },
    { key: 'taxiId', label: 'Taxi Driver', sortable: true },
    { key: 'accountId', label: 'Account', sortable: true },
    { key: 'bookingId', label: 'Booking', sortable: true },
    { key: 'postId', label: 'Post', sortable: true },
    { key: 'tourId', label: 'Tour', sortable: true },
    { key: 'amount', sortable: true },
    { key: 'transactionDateUtc', label: 'Date', sortable: true },
    { key: 'actions' },
  ];

  const pageNumber = ref(1);
  const orderDesc = ref(true);
  const pageSize = ref(10);
  const refTransactionList = ref(null);
  const orderBy = ref('id');
  const totalTansactions = ref(0);

  const taxi = ref(
    localStorage.getItem('taxiTransactionList-taxi') == 'null'
      ? null
      : JSON.parse(localStorage.getItem('taxiTransactionList-taxi'))
  );
  const transactionStatus = ref(
    localStorage.getItem('taxiTransactionList-transactionStatus') == 'null'
      ? null
      : JSON.parse(
          localStorage.getItem('taxiTransactionList-transactionStatus')
        )
  );
  const searchQuery = ref(
    localStorage.getItem('taxiTransactionList-searchQuery') == ''
      ? ''
      : localStorage.getItem('taxiTransactionList-searchQuery')
  );
  const searchByDate = ref(
    localStorage.getItem('taxiTransactionList-searchByDate') == ''
      ? ''
      : localStorage.getItem('taxiTransactionList-searchByDate')
  );

  const dataMeta = computed(() => {
    const localItemsCount = refTransactionList.value
      ? refTransactionList.value.localItems.length
      : 0;
    return {
      from: pageSize.value * (pageNumber.value - 1) + (localItemsCount ? 1 : 0),
      to: pageSize.value * (pageNumber.value - 1) + localItemsCount,
      of: totalTansactions.value,
    };
  });

  watch([pageNumber, pageSize, taxi, transactionStatus, searchByDate], () => {
    localStorage.setItem(
      'taxiTransactionList-transactionStatus',
      JSON.stringify(transactionStatus.value)
    );
    localStorage.setItem(
      'taxiTransactionList-taxi',
      JSON.stringify(taxi.value)
    );
    localStorage.setItem(
      'taxiTransactionList-searchByDate',
      searchByDate.value
    );
    refTransactionList.value.refresh();
  });

  const refreshTable = () => {
    localStorage.setItem('taxiTransactionList-searchQuery', searchQuery.value);
    refTransactionList.value.refresh();
  };

  const clearSearchByDate = () => {
    searchByDate.value = '';
  };

  const getTransactionList = (_, callback) => {
    const params = {
      orderBy: orderBy.value,
      orderDesc: orderDesc.value,
      searchByDate: searchByDate.value === '' ? null : formatDateYyyyMmDd(convertDateToUTC(searchByDate.value)),
      pageSize: pageSize.value,
      pageNumber: pageNumber.value,
      taxiId: taxi.value?.id ?? undefined,
      transactionStatusId: transactionStatus.value?.id ?? undefined,
      searchQuery: searchQuery.value,
    };

    fetchTransactions(params).then(({ transactions, total }) => {
      callback(transactions);
      totalTansactions.value = total;
    });
  };

  return {
    // Const
    perPageOptions,
    tableColumns,

    // Reactive
    orderBy,
    orderDesc,
    pageNumber,
    pageSize,
    refTransactionList,
    searchQuery,
    taxi,
    transactionStatus,
    totalTansactions,
    searchByDate,

    // Computed
    dataMeta,

    // Method
    getTransactionList,
    clearSearchByDate,
    refreshTable,
  };
};

export default useTaxiTransactionsList;
